import Swal from "sweetalert2";
import { config } from "./CommonURLS";
import { CommonAxiosPostLogin } from "./CommonAxios";

const SUPPORTED_IMAGE_FORMATS1 = ['image/jpg', 'image/jpeg', 'image/png'];
const SUPPORTED_PDF_FORMAT = 'application/pdf';


function ValidateFilesTypeAndSize(customefile, filetype) {
    let errormsg = "";
    if (filetype === "image") {
        if (!SUPPORTED_IMAGE_FORMATS1.includes(customefile.type)) {
            errormsg += "Please upload only .jpg, .jpeg, or .png ,\n";
            customefile.value = '';
        }

        // if (customefile?.size < 1024 || customefile?.size > 102400) {
        if (customefile?.size > 5242880) {
            errormsg += "size should be up to to  5 Mb.\n";
            customefile.value = '';
        }
    }
    else if (filetype === "pdf") {
        if (customefile.type !== SUPPORTED_PDF_FORMAT) {
            errormsg += "Please upload a .pdf file.\n";
            customefile.value = '';
        }
        if (customefile.size > 2097152) {
            errormsg += "size should be up to 2 MB.\n";
            customefile.value = '';
        }
    }
    else {
        errormsg += "Invalid file type. Please upload an image or PDF.\n";
        customefile.value = '';
    }
    if (errormsg !== "") {
        Swal.fire({
            icon: 'error',
            title: 'Invalid file',
            text: errormsg,
            confirmButtonText: 'OK',
        });
        return false;
    }

    return true;
}

export function ImagePdfBucket(e, formIk, path, name, filename, filetype) {
    e.preventDefault();
    const file = e.target.files[0]; // Original file
    const type = file.type.split("/")[1]; // file type
    const newFileName = filename + "." + type; // New file name
    console.log("newFileName---->>", newFileName);
    const modifiedFile = new File([file], newFileName, { type: file.type });
    if (ValidateFilesTypeAndSize(modifiedFile, filetype)) {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("file", modifiedFile);
            CommonAxiosPostLogin(config.url.FILE_UPLOAD_URL + path, formData).then((response) => {
                resolve(response.data)
                if (response?.data !== undefined) {
                    formIk.setFieldValue(name, response?.data);
                    console.log("after post----->>", response?.data)
                } else {
                    Swal.fire({
                        text: "Image/pdf Upload Failed",
                        icon: "warning",
                        backdrop: false,
                    }).then((refresh) => {
                        if (refresh.isConfirmed) {
                            formIk.setFieldValue(name, "");
                        }
                    })
                }
            }).catch((error) => {
                console.log("error at imagebucket", error)
                resolve(null);
            });

        });
    } else {
        e.target.value = '';
    }
}